<template>
<base-dashboard-layout :menu-options="menuOptions"></base-dashboard-layout>
</template>

<script>
import {School, Create, Clipboard} from "@vicons/ionicons5"

import baseDashboardLayout from "./baseDashboardLayout.vue";

import {renderRouteLabel} from "../../utils/menu.js";

export default {
    name: "dashboardLayout",
    data () {
        return {
            menuOptions: this.getMenuOptions(localStorage.getItem("role"))
        }
    },
    components: {
        baseDashboardLayout
    },
    methods: {
        getMenuOptions(role) {
            const menuOptions = [];
            if (role === 'admin') {
                menuOptions.push(renderRouteLabel("/teacher/teacherList", "Teachers", "teacherList", School));
                menuOptions.push(renderRouteLabel("/teacher/classList", "Classes", "classList", School));
                menuOptions.push(renderRouteLabel("/teacher/taskList", "Tasks", "taskList", Clipboard));
            } else if (role === 'teacher') {
                menuOptions.push(renderRouteLabel("/teacher/classList", "Classes", "classList", School));
                menuOptions.push(renderRouteLabel("/teacher/newTask", "New Task", "newTask", Create));
                menuOptions.push(renderRouteLabel("/teacher/taskList", "Tasks", "taskList", Clipboard));
            } else {
                menuOptions.push(renderRouteLabel("/student/taskList", "Tasks", "studentTaskList", Clipboard));
            }
            return menuOptions;
        }
    }
}
</script>


<style scoped>
</style>
